// FaqCustomDialog.js
import {
  Button,
  Dialog,
  DialogContent,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import TextInput from "../../components/textInput";

// Styled Dialog
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(5, 4),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4),
    },
  },
  "& .MuiPaper-root": {
    width: "550px",
    borderRadius: "20px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
}));

// Main Dialog Component
let paramsData = {};
const FaqCustomDialog = forwardRef(
  ({ dialogType, handleCreate, inputValues, handleChange }, ref) => {
    const [open, setOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openDialog(params) {
        paramsData = params;
        setOpen(true);
      },
      closeDialog() {
        setOpen(false);
      },
    }));

    const closeDialog = () => {
      setOpen(false);
    };
    console.log(paramsData, "paramsDataparamsDataparamsData");

    return (
      <BootstrapDialog onClose={closeDialog} open={open}>
        <DialogContent>
          <Typography
            fontSize={"1.375rem"}
            fontWeight={600}
            textAlign={"center"}
            color={"primary.light"}
          >
            {dialogType === "edit" ? "Edit FAQ" : "Create FAQ"}
          </Typography>

          <InputLabel>Faq Title</InputLabel>
          <TextInput
            value={inputValues.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />
          <Stack mt={1} />
          <InputLabel>Description</InputLabel>
          <TextInput
            multiline={true}
            value={inputValues.description}
            onChange={(e) => handleChange("description", e.target.value)}
          />

          <Stack direction="row" alignItems="center" gap={1} mt={4}>
            <Button
              variant="custom_outlined"
              onClick={() => handleCreate(paramsData, dialogType)}
              endIcon={
                <img
                  src={APP_ICONS.fileSaveIconBlue}
                  width={22}
                  alt="Save Icon"
                />
              }
            >
              {dialogType === "edit" ? "Save" : "Create"}
            </Button>
            <Button variant="suspend_button" onClick={closeDialog}>
              Discard
            </Button>
          </Stack>
        </DialogContent>
      </BootstrapDialog>
    );
  }
);

export default FaqCustomDialog;
